import React, {PureComponent} from "react";
import Api from "../../utils/api_calls";
import GridItem from "./GridItem/GridItem";
import SearchItem from "./SearchItem/SearchItem";
import Analytics from "../../libs/analytics";
import * as actionTypes from "../../store/actions";
import { StoreContext } from "../../contexts/store";
import {createBrowserHistory} from 'history';
import "./Grid.scss";
import Dots from "../../ui/Dots/Dots";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";

let history = createBrowserHistory();

const Loading = () => (
    <div className="col-12 d-flex loading justify-content-center">
        <Dots/>
    </div>
)

class Grid extends PureComponent {
    static contextType = StoreContext;

    constructor(props) {
        super(props);
        const {termToSearch, currentAsset} = props;
        this.state = {
            assets: [],
            page: -1,
            currentAsset: currentAsset,
            searchTerm: termToSearch,
            loading: false,
            enableLoading: false
        };
    }

    storeSubscribeGrid = (storeState) => {
        if (storeState.event === actionTypes.PLAYER_EVENT) {
            if (storeState.player_event !== 'tvp:media:videoended') return;
            let index = 0;
            const assets = this.state.assets;
            const assetsQty = assets.length;
            for (let i = 0; i < assetsQty; i++) {
                if (assets[i].id == this.state.currentAsset) {
                    if (i === (assetsQty - 1))
                        index = 0;
                    else
                        index = ++i;
                }
            }
            const asset = assets[index];
            if (asset.entityType === 1 && assetsQty === 1) return;
            //history.push(Common.generateAssetUrlFrom(asset));
            this.context.dispatch({
                type: actionTypes.UPDATE_ASSET,
                asset: asset
            });


        } else if (storeState.event === actionTypes.UPDATE_ASSET) {
            setTimeout(this.setState({
                currentAsset: storeState.asset.id
            }), 200);

        }

    }

    componentDidMount() {
        this.loadMoreAssets();
        window.addEventListener("scroll", this.onScroll);
        this._lastStoreState = this.context.state;
    }

    componentDidUpdate() {
        const storeState = this.context.state;
        if (storeState === this._lastStoreState) return;
        this._lastStoreState = storeState;
        this.storeSubscribeGrid(storeState);
    }
    
    loadMoreAssets = () => {
        const {loading} = this.state;
        if (loading) return;
        this.setState({loading: true});

        const {baseApiUrl} = this.props;
        const {page, searchTerm} = this.state;
        const pageToLoad = page + 1;

        Api.content(baseApiUrl, pageToLoad, searchTerm)
            .then(this.setAssetsFromResponse);
    }

    onScroll = () => {
        const {loading, enableLoading} = this.state;
        if (loading) return;

        const scrollTo = window.pageYOffset || document.documentElement.scrollTop;
        const newWindowHeight = document.documentElement.offsetHeight - window.innerHeight;
        const percentDocument = (scrollTo * 100) / newWindowHeight;
        if (percentDocument > 80 && enableLoading) {
            this.loadMoreAssets();
        }
    }

    setAssetsFromResponse = (response) => {
        const {assets, page, searchTerm} = this.state;
        const {data} = response, {result} = data;

        let newState = {};
        if ((data && data.length) || (result && result.length)) {
            let assetsRes;
            if (result) {
                assetsRes = result;
                assetsRes.forEach((assetItem) => {
                    assetItem.asset = assetItem.asset ? assetItem.asset : JSON.parse(assetItem.data);
                    assetItem.asset.thumbnailUrl = assetItem.asset.asset.thumbnailUrl;
                });
            } else {
                assetsRes = data
            }
            if (assetsRes.length > 0 && this.props.pmEvent && page === -1 && !searchTerm){
                Analytics.pmEvent(assetsRes[0]);
            }
            newState = {
                assets: assets.concat(assetsRes),
                page: page + 1,
                enableLoading: assetsRes.length > 0
            };
        } else {
            newState.enableLoading = false;
            if(page === -1 && this.props.noResultsCallback)
                this.props.noResultsCallback();
        }
        newState.loading = false;
        this.setState(newState);
    }

    getGridItemFromAsset = (asset, key) => {
        const {redirect, lazyLoadingThumbnails} = this.props;
        const {currentAsset, searchTerm} = this.state;
        if(searchTerm){
            return <SearchItem
                asset={asset}
                lazyLoadingThumbnails={lazyLoadingThumbnails}
                key={key}/>;
        }else{
            return <GridItem
                dataTestid="tvp-grid-item"
                asset={asset}
                playing={asset.id === currentAsset}
                redirect={redirect}
                maxDescriptionLines={3}
                lazyLoadingThumbnails={lazyLoadingThumbnails}
                key={key}/>;
        }

    }

    render() {
        const {assets, loading, enableLoading, searchTerm} = this.state;
        const gridItems = assets.map(this.getGridItemFromAsset);
        const {gridTitle} = this.props;
        return (
            <div data-testid="tvp-grid" className="container tvp-grid pb-4">
                <div className="row">
                    {gridTitle && <h1 className="col-12 grid-title text-center">{gridTitle}</h1>}
                </div>
                <div className={"row "+(searchTerm ? "is-search" : "")}>
                    {gridItems}
                    {loading && <Loading/>}
                    {(!enableLoading && searchTerm || (!loading && !assets.length)) && <div className={"no-results"}>No results found.</div>}
                </div>
            </div>
        );
    }
}

Grid.defaultProps = {
    gridTitle: "Watch the latest",
    baseApiUrl: `${ConfigurationHelper.getGlobalConfiguration().apiUrl}/videos/search`,
    currentAsset: 0,
    redirect: true,
    pmEvent: false,
    noResultsCallback: ()=>{},
    showNoResults: false,
    lazyLoadingThumbnails: true
};

export default Grid;